import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function IncludesSection() {
  const features = ['Plan completo paso a paso', 'Sistema de Filtro Femenino™', 'Scripts de mensajes', 'Plantillas de evaluación', 'Plan 7–14–30 días', 'Tablero Notion'];
  return <Section className="bg-[#FAF8F5]" data-id="element-69">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-70">
        <div data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D2D2D] mb-8" data-id="element-72">
            QUÉ INCLUYE
          </h2>
          <div className="grid gap-4" data-id="element-73">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-sm border border-[#D4735E]/5" data-id="element-74">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#D4735E]/10 flex items-center justify-center" data-id="element-75">
                  <Check className="w-3.5 h-3.5 text-[#D4735E]" data-id="element-76" />
                </div>
                <span className="text-lg text-[#2D2D2D] font-medium" data-id="element-77">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>

        <div className="bg-[#D4735E] text-white p-8 md:p-12 rounded-2xl" data-id="element-78">
          <h3 className="text-2xl font-serif font-bold mb-4" data-id="element-79">Formato: PDF</h3>
          <p className="text-lg opacity-90 leading-relaxed" data-id="element-80">
            Directo al grano diseñado para aplicar mientras sigues con tu vida
            real. Sin relleno, solo estrategia.
          </p>
        </div>
      </div>
    </Section>;
}